import { createRouter, createWebHistory } from "vue-router";
import MainLayout from "../layouts/MainLayout.vue";
import CustomBundleLayout from "../layouts/CustomBundleLayout.vue";
import LoginLayout from "../layouts/LoginLayout.vue";
import Dashboard from "../views/Dashboard.vue";
import Wallet from "../views/Wallet/Wallet.vue";
import AllCategory from "../views/Category/AllCategory.vue";
import CategoryCourses from "../views/Courses/CategoryCourses.vue";
import Cart from "../views/Cart/Show.vue";
import CourseDetails from "../views/CourseDetails/index.vue";
import BundleDetails from "../views/BundleDetails/index.vue";
import Settings from "../views/Settings/index.vue";
import Home from "../views/Home/index.vue";
import Login from "../views/Login.vue";
import Register from "../views/Register.vue";
import Logout from "../views/Logout.vue";
import CustomBundle from "../views/CustomBundle/index.vue";
// Qbank -------
import QbankHome from "../views/Qbank/Home/index.vue";
import QuizList from "../views/Qbank/QuizList/index.vue";
import QbankSummary from "../views/Qbank/QbankSummary/index.vue";
import QbankSubscribe from "../views/Qbank/Subscribe/index.vue";
import QuizTutor from "../views/Qbank/Quiz/Tutor/index.vue";
import QuizTimed from "../views/Qbank/Quiz/Timed/index.vue";
import QuizReview from "../views/Qbank/Quiz/Review/index.vue";
import Plan from "../views/Qbank/Plan/newPlan.vue";

//End Qbank
const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/Dashboard",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "Dashboard",
        component: Dashboard,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/home",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "Home",
        component: Home,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/custome-bundle-share",
    component: CustomBundleLayout,
    children: [
      {
        path: "",
        name: "customebundleshare",
        component: CustomBundle,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/AllCategory",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "AllCategory",
        component: AllCategory,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/Wallet",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "Wallet",
        component: Wallet,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/Cart",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "Cart",
        component: Cart,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/CategoryCourses",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "CategoryCourses",
        component: CategoryCourses,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/Settings",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "Settings",
        component: Settings,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/course-details",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "CourseDetails",
        component: CourseDetails,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/bundle-details",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "BundleDetails",
        component: BundleDetails,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/login",
    component: LoginLayout,
    children: [
      {
        path: "",
        name: "Login",
        component: Login,
      },
    ],
  },
  {
    path: "/register",
    component: LoginLayout,
    children: [
      {
        path: "",
        name: "Register",
        component: Register,
      },
    ],
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout,
  },

  //Qbank ----

  {
    path: "/qbank-acad-feature",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "QbankHome",
        component: QbankHome,
      },
    ],
  },
  {
    path: "/qbank-subscribe",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "QbankSubscribe",
        component: QbankSubscribe,
      },
    ],
  },
  {
    path: "/qbank-quiz-timed",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "QuizTimed",
        component: QuizTimed,
      },
    ],
  },
  {
    path: "/qbank-quiz-tutor",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "QuizTutor",
        component: QuizTutor,
      },
    ],
  },
  {
    path: "/qbank-summary",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "QbankSummary",
        component: QbankSummary,
      },
    ],
  },
  {
    path: "/qbank-plan",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "Plan",
        component: Plan,
      },
    ],
  },
  {
    path: "/qbank-quiz-review",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "QuizReview",
        component: QuizReview,
      },
    ],
  },
  {
    path: "/qbank-list-quiz",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "QuizList",
        component: QuizList,
      },
    ],
  },
  //End -----
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
